import React from 'react';
import { Form, Input } from 'antd';
import { formLayout } from '@bluevision/tools';
import { LockOutlined } from '@ant-design/icons';
import type { SimpleFunc } from '@bluevision/tools';
import { useTranslation } from 'react-i18next';

import ToggleRender from '@/components/Render/ToggleRender';
import CEditModalForm from '@/components/CModal/CEditModal/Content';
import ConfirmPassword from '@/components/CForm/ConfirmPassword';
import { modifyPassword } from '@/services/authority/login';

const { tailLayout } = formLayout;

type IChangePasswordProps = {
  onClose: SimpleFunc;
  visible?: boolean;
};

const ChangePassword: React.FC<IChangePasswordProps> = ({ visible, onClose }) => {
  const { t } = useTranslation();

  return (
    <ToggleRender visible={visible}>
      <CEditModalForm
        formProps={tailLayout}
        btnText={t('change_password')}
        onClose={onClose}
        service={modifyPassword}
      >
        <Form.Item
          label={t('old_password')}
          name='curPassword'
          rules={[{ required: true, message: t('please_enter_old_password') }]}
        >
          <Input.Password
            placeholder={t('please_enter')}
            prefix={<LockOutlined />}
            autoComplete='new-password'
          />
        </Form.Item>
        <ConfirmPassword />
      </CEditModalForm>
    </ToggleRender>
  );
};
export default ChangePassword;
